import * as React from 'react';
export const earlygrowthSvg = React.forwardRef(function earlygrowthSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#ADAE52',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#3D710E',
        d: 'M10.45 5.17c.03-.15.19-.71.76-1l-.01-.05a33.23 33.23 0 0 1 9.03 19.31l-2.5 3.92a77.47 77.47 0 0 0-6.49-23.1c-.24.17-.56.47-.65 1.01.64.73.6 1.75.6 1.75 0 2.89-2.81 3.63-2.81 3.63.18-.6 0-2.58 0-2.58l2.06-2.89z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M17.7 28s2.45-8.23 8.23-15.83c0 0-4.75 13.07-4.81 15.83H17.7zM6 9.04s.88-1.08 1-2.64c.1-1.54 1.56-1.97 2.23-1.91 0 0-.81.69-1.07 1.98-.1.51-.42.9-.42.9s.71-.13.98-1.24c.26-1.05 1.21-1.7 2.28-1.96l.18-.05.07.08c-.88.25-1.16.47-1.2.65-.04.25 1.15 1.12-.6 2.95C7.7 9.62 6 9.04 6 9.04',
      }),
    ),
  );
});
earlygrowthSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var earlygrowth = {
  category: 'brand',
  colorable: false,
  name: 'earlygrowth',
  svg: earlygrowthSvg,
};
